import {
  Code,
  Database,
  Server,
  Monitor,
  TabletSmartphone,
  Workflow,
} from "lucide-react";
export const experiencesByCompany = {
  Applab: [
    {
      company: "Applab",
      role: "Frontend Developer",
      duration: "Aug 2024 - Present",
      location: "Doha, Qatar",
      description: "Working on CMS Strapi, Angular JS for Qatar Survey, and Kony Mobile applications including Metrash2 with i18n translations, UI implementation, and custom components.",
      projects: [{ title: "MetrashX CMS", link: "" }, { title: "Qatar Survey", link: "" }, { title: "Metrash2", link: "https://apps.apple.com/us/app/metrash/id6470879050" }],
      tech: ["Strapi", "Angular JS", "Kony", "PostgreSQL", "i18n"],
    },
    {
      company: "Applab",
      role: "VoltMX/Kony Developer",
      duration: "Dec 2023 - Aug 2024",
      location: "Doha, Qatar",
      description: "Developed Kony Mobile Application for Qatar Rail with VoltMX Foundry Integration, push notification, and payment features.",
      projects: [{ title: "Qatar Rail", link: "https://apps.apple.com/us/app/qatar-rail/id962317816" }],
      tech: ["VoltMX", "Kony", "i18n", "Payment Integration"],
    },
    {
      company: "Applab",
      role: "NextJS Developer",
      duration: "Sep 2023 - Dec 2023",
      location: "Doha, Qatar",
      description: "Built NextJS web application for Hayya with features like stepper form, carousel, and i18n translations.",
      projects: [{ title: "Hayya", link: "https://hayya.qa" }],
      tech: ["NextJS", "Redux", "i18n"],
    },
    {
      company: "Applab",
      role: "ReactJS Developer",
      duration: "Mar 2023 - Sep 2023",
      location: "Doha, Qatar",
      description:
        "Developed ReactJS web application for Hukoomi with chatbot, OpenAI integration, cognitive search, and SEO optimization.",
      projects: [{ title: "Hukoomi", link: "https://hukoomi.gov.qa" }],
      tech: ["React", "OpenAI", "SEO", "i18n", "Docker"],
    },
  ],
  Appstation: [
    {
      company: "Appstation",
      role: "React Developer",
      duration: "Sep 2022 - Mar 2023",
      location: "Trivandrum, India",
      description:
        "Built Social Charity system, Qatar Foundation application using Gatsby, and Loom using NextJS.",
      projects: [{ title: "Social Charity System", link: "" }, { title: "Qatar Foundation", link: "https://www.qf.org.qa" }, { title: "Loom", link: "https://loom.qa" }],
      tech: ["React", "Gatsby", "NextJS"],
    },
  ],
  Infovision: [
    {
      company: "Infovision",
      role: "React Developer",
      duration: "June 2021 - Aug 2022",
      location: "Coimbatore, India",
      description:
        "The project is entirely built with Material UI and Ant Design. This is a role-based application like hierarchy model. Question and Answer Module, Survey Module, Task Allocation for store managers. The task can Drag and Drop scheduled dates. ",
      projects: [{ title: "Cybersoft School Cafe application", link: "" }, { title: "7-Eleven", link: "" }],
      tech: ["React", "Typescript", "Javascript"],
    },
    {
      company: "Infovision",
      role: "React Developer",
      duration: "Feb 2021 - June 2021",
      location: "Coimbatore, India",
      description:
        "Online Purchasing Application, Order status tracking, Online Payments, Profile Maintenance. The stores are partially automated, with customers able to purchase products without being checked out by a cashier or using a self-checkout station. Online Payments, Store Search and detail in Map, QR Authentication, AWS amplifyintegration",
      projects: [{ title: "E-commerce", link: "" }, { title: "Express Store", link: "" }],
      tech: ["React Native", "Typescript"],
    },
  ],
  Katomaran: [
    {
      company: "Katomaran",
      role: "Full Stack Developer",
      duration: "Jan 2020 - Feb 2021",
      location: "Coimbatore, India",
      description: "",
      projects: [
        { title: "Smart Condo Management", link: "https://apps.apple.com/in/app/smart-condo-sg/id1596565327" },
        { title: "Building Water Pump System", link: "" },
        { title: "Deccan Pump System", link: "" },
      ],
      tech: [
        "ReactJS",
        "React Native",
        "Ruby on Rails",
        "PostgreSQL",
        "Docker",
        "CI/CD",
        "GrayLog",
        "Honey Badger Logs",
        "Cron JOB",
        "Micro Services",
        "Material UI",
        "Ant Design"
      ],
    },
  ],
};

export const skills = [
  {
    category: "Web App",
    items: [
      "React",
      "Angular",
      "Next",
      "Gatsby",
      "TypeScript",
      "JavaScript",
      "HTML/CSS",
      "Redux",
      "Thunk",
      "Saga"
    ],
    icon: <Monitor className="text-blue-400 mr-2" size={20} />,
  },
  {
    category: "Mobile App",
    items: ["React Native", "Kony", "VoltMX", "Swift UI", "iOS", "Redux", "Thunk", "Saga"],
    icon: <TabletSmartphone className="text-blue-400 mr-2" size={20} />,
  },
  {
    category: "Backend",
    items: ["Ruby on Rails", "Node.js", "RESTful APIs", "PostgreSQL", "Python"],
    icon: <Server className="text-blue-400 mr-2" size={20} />,
  },
  {
    category: "Tools",
    items: ["Git", "Docker", "Postman", "VS Code", "Jira", "Azure DevOps"],
    icon: <Code className="text-blue-400 mr-2" size={20} />,
  },
  {
    category: "Cloud",
    items: ["AWS", "GCP", "Digital Ocean"],
    icon: <Database className="text-blue-400 mr-2" size={20} />,
  },
  {
    category: "Integrations",
    items: ["MailGun", "AWS SES", "AWS S3", "Cron Job", "UptimeRobot", "MQTT", "Docker", "CI/CD Pipeline", "Deployment"],
    icon: <Workflow className="text-blue-400 mr-2" size={20} />,
  },
];

export const projects = [
  {
    name: "Yatra Connect - Community Engagement & Workflow Management Platform",
    description:
      "Yatra Connect is a comprehensive mobile ecosystem built to streamline communication, event coordination, and administrative workflows for a large-scale organization. I developed the cross-platform application from the ground up, implementing a real-time messaging system via ActionCable (WebSockets) that supports group dynamics, media sharing, and read receipts. The platform features a sophisticated hierarchical management system ('Chakras' and Departments), enabling role-based access for event approvals, financial tracking, and organizational analytics. Integrated with Firebase for secure authentication and high-performance push notifications with deep-linking, the app ensures seamless connectivity and simplified governance for its users.",
    tech: ["React Native", "Redux Toolkit", "ActionCable", "Firebase", "Reanimated", "Glassmorphic UI"],
    link: "",
  },
  {
    name: "Hukoomi",
    description:
      "Hukoomi is Qatar’s official e-Government portal with OpenAI-powered chatbot and cognitive search implementation. I developed the frontend from scratch using ReactJS and integrated it with a .NET-based backend. The platform provides citizens, residents, and businesses with access to a wide range of government services and information online. It offers services related to visas, health, education, transportation, legal affairs, and more — all aimed at simplifying and digitizing public services across Qatar.",
    tech: ["React", "OpenAI", "i18n", "SEO", "Redux"],
    link: "https://hukoomi.gov.qa",
  },
  {
    name: "Hayya",
    description:
      "Hayya is Qatar’s official portal for managing visitor access and services for major events. I had the opportunity to develop the entire platform from scratch using Next.js, building the full user journey from registration to final approval. The platform offers features like face detection for secure identity verification, sleek animations, and a refined, user-centric design.\n\nIt supports multiple visa types including:\n\n• Hayya with Me (for friends and family)\n• Fan Entry Visa\n• GCC Resident Visa\n• Entry Visa for Events\n\nThese services are streamlined through a smooth digital experience covering visa application, accommodation booking, and event access — all within a single platform.",
    tech: ["Next.js", "OpenAI", "i18n", "SEO", "Redux"],
    link: "https://hayya.qa",
  },
  {
    name: "Qatar Rail",
    description:
      "Qatar Rail’s mobile application was built with VoltMX Foundry integration for robust backend services. I contributed by developing key modules in Kony (now VoltMX), including push notifications, multilingual support (i18n), and payment integration for travel cards and services. The app streamlines the commuter experience with real-time updates, route planning, and secure transactions.",
    tech: ["Kony", "VoltMX", "i18n", "Payment"],
    link: "https://www.qr.com.qa",
  },
  {
    name: "Metrash2",
    description:
      "Metrash2 is an essential government service mobile application in Qatar. I worked on developing key modules using Kony (VoltMX), integrating backend services through Kony Fabric and SOAP APIs. The app supports bilingual access (Arabic/English), secure payment gateways, and push notifications, allowing residents to access visa, traffic, and ID services efficiently.",
    tech: ["Kony", "SOAP", "i18n"],
    link: "https://apps.apple.com/ca/app/metrash2/id490584844",
  },
  {
    name: "Smart Condo Management",
    description:
      "React Native app for condo residents with features for inviting guests and raising complaints",
    tech: ["React Native", "Firebase", "Notifications"],
    link: "https://apps.apple.com/in/app/smart-condo-sg/id1596565327",
  },
];

export const additionalSkills = [
  {
    title: "Development Process",
    points: [
      "Agile/Scrum Methodology",
      "CI/CD Implementation",
      "Test-Driven Development",
      "Code Reviewing",
    ],
  },
  {
    title: "Development Features",
    points: [
      "i18n Multilingual Support",
      "Payment Gateway Integration",
      "Push Notification Systems",
      "Role-Based Access Control",
    ],
  },
];


export const notableProjects = [
  {
    name: "Qatar Foundation",
    description: "Developed an accessible, multilingual website for Qatar Foundation using Gatsby. Implemented responsive layouts, optimized performance with SSG, and integrated with various APIs for event management and educational content.",
    link: "https://www.qf.org.qa/",
    tech: ["Gatsby", "GraphQL", "Internationalization"]
  },
  {
    name: "Loom",
    description: "NextJS application with modern UI components",
    link: "https://loom.qa/",
    tech: ["Next.js", "Internationalization"]
  },
  {
    tech: ["React", "IoT", "Python", "Ruby on rails", "React Native", "MQTT"]
  }
];

export const blogPosts = [
  {
    id: "scalable-react-apps",
    title: "How to build scalable React apps",
    desc: "Best practices for architecting large-scale React applications with focus on performance and maintainability.",
    date: "January 20, 2024",
    content: `
      <p>Building large-scale React applications requires more than just knowing the library; it requires a deep understanding of architectural patterns, state management, and performance optimization.</p>
      
      <h3>1. Folder Structure</h3>
      <p>A scalable folder structure is the foundation of a maintainable project. We recommend a feature-based structure where components, hooks, and services related to a specific feature are grouped together.</p>
      
      <h3>2. State Management</h3>
      <p>While React's built-in state management is powerful, larger apps often benefit from libraries like Redux Toolkit or Zustand. The key is to keep global state minimal and use local state whenever possible.</p>
      
      <h3>3. Performance Optimization</h3>
      <p>Use React.memo, useMemo, and useCallback to prevent unnecessary re-renders. Additionally, implement code-splitting using React.lazy and Suspense to reduce initial load times.</p>
      
      <h3>4. Testing</h3>
      <p>Maintain high code quality with automated tests using Jest and React Testing Library. Testing business logic and critical UI interactions ensures that new changes don't break existing functionality.</p>
    `
  },
  {
    id: "react-native-performance",
    title: "React Native performance tips",
    desc: "Optimizing your mobile apps for smooth 60fps animations and rapid response times.",
    date: "January 15, 2024",
    content: `
      <p>React Native offers the ability to build high-quality mobile apps with JavaScript, but performance can be a challenge if not handled correctly.</p>
      
      <h3>1. Use the Hermes Engine</h3>
      <p>Hermes is a small and lightweight JavaScript engine optimized for running React Native on Android. It helps decrease memory usage, reduce app size, and improve startup time.</p>
      
      <h3>2. Optimize Images</h3>
      <p>Use appropriately scaled images and consider using formats like WebP. For complex lists, use FlatList or SectionList which are optimized for large datasets.</p>
      
      <h3>3. Native Driver for Animations</h3>
      <p>Always use the native driver for animations by setting <code>useNativeDriver: true</code> in your Animated configurations. This moves the animation logic to the native thread, ensuring 60fps even when the JS thread is busy.</p>
    `
  },
  {
    id: "fullstack-architecture-startups",
    title: "Full stack architecture for startups",
    desc: "Choosing the right stack and architecture to scale from MVP to millions of users.",
    date: "January 10, 2024",
    content: `
      <p>Startups need to move fast, but they also need a foundation that won't crumble as they scale. A well-chosen full stack architecture can be a competitive advantage.</p>
      
      <h3>1. Monolith vs. Microservices</h3>
      <p>For most startups, starting with a well-structured monolith is the right choice. It simplifies development, deployment, and testing. Only move to microservices when the organizational complexity warrants it.</p>
      
      <h3>2. Choosing the Database</h3>
      <p>PostgreSQL is often the safest bet for startups due to its reliability and support for both relational and JSON data. Use Redis for caching to speed up read-heavy operations.</p>
      
      <h3>3. API Design</h3>
      <p>REST remains a solid choice for most applications, but GraphQL can offer benefits for complex data requirements. Ensure your API is well-documented and versioned from the start.</p>
    `
  },
  {
    id: "frontend-best-practices",
    title: "Best practices for frontend development",
    desc: "Modern frontend workflows, accessibility, and state management strategies.",
    date: "January 5, 2024",
    content: `
      <p>Modern frontend development is about more than just UI; it's about accessibility, performance, and developer experience.</p>
      
      <h3>1. Component-Driven Development</h3>
      <p>Build your UI using a component-driven approach. Tools like Storybook can help you develop and test components in isolation before integrating them into the app.</p>
      
      <h3>2. Accessibility (a11y)</h3>
      <p>Accessibility should never be an afterthought. Use semantic HTML, proper ARIA labels, and ensure your site is keyboard-navigable. Tools like axe-core can help automate accessibility testing.</p>
      
      <h3>3. Type Safety</h3>
      <p>Adopting TypeScript is one of the best ways to improve code quality and developer productivity. It catches errors early and provides excellent IDE support.</p>
    `
  },
  {
    id: "secure-backend-apis",
    title: "Building secure backend APIs",
    desc: "Essential security patterns for RESTful and GraphQL APIs to protect user data.",
    date: "January 1, 2024",
    content: `
      <p>Security is paramount when building backend services. Protecting user data and preventing unauthorized access should be a top priority.</p>
      
      <h3>1. Authentication and Authorization</h3>
      <p>Use standard protocols like OAuth2 or JWT for authentication. Implement fine-grained role-based access control (RBAC) to ensure users only access the data they are permitted to see.</p>
      
      <h3>2. Input Validation and Sanitization</h3>
      <p>Never trust user input. Validate all incoming data against a schema and sanitize it to prevent SQL injection and cross-site scripting (XSS) attacks.</p>
      
      <h3>3. Rate Limiting and Monitoring</h3>
      <p>Protect your API from abuse by implementing rate limiting. Use logging and monitoring tools like Sentry or GrayLog to detect and respond to security incidents in real-time.</p>
    `
  }
];